import React, { useState } from 'react';
import './FAQContent.css';

// Иконка плюс (закрытый вопрос)
const PlusIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 4V16M4 10H16" stroke="#838383" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Иконка минус (открытый вопрос)
const MinusIcon = () => (
  <svg width="20" height="2" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1H19" stroke="#c0c0c0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Функция для преобразования текста с URL и <b> тегами в React элементы
const formatText = (text) => {
  // Сначала разбиваем текст по <b> тегам
  const parts = [];
  let remaining = text;
  let key = 0;

  // Регулярное выражение для поиска URL
  const urlRegex = /(https?:\/\/[^\s]+)|((?:t\.me|vk\.com)\/[^\s]+)/gi;

  // Функция для обработки ссылок в тексте
  const processLinks = (str) => {
    const linkParts = [];
    let lastIndex = 0;
    let match;
    const regex = new RegExp(urlRegex.source, 'gi');

    while ((match = regex.exec(str)) !== null) {
      if (match.index > lastIndex) {
        linkParts.push(str.slice(lastIndex, match.index));
      }
      
      const url = match[0];
      const href = url.startsWith('http') ? url : `https://${url}`;
      
      linkParts.push(
        <a 
          key={`link-${key++}`}
          href={href} 
          target="_blank" 
          rel="noopener noreferrer"
          className="faq-content__link"
        >
          {url}
        </a>
      );
      
      lastIndex = match.index + url.length;
    }
    
    if (lastIndex < str.length) {
      linkParts.push(str.slice(lastIndex));
    }
    
    return linkParts.length > 0 ? linkParts : str;
  };

  // Разбиваем по <b> тегам
  const boldRegex = /<b>(.*?)<\/b>/gs;
  let lastIndex = 0;
  let match;

  while ((match = boldRegex.exec(remaining)) !== null) {
    // Добавляем текст до <b>
    if (match.index > lastIndex) {
      const beforeText = remaining.slice(lastIndex, match.index);
      parts.push(<React.Fragment key={`text-${key++}`}>{processLinks(beforeText)}</React.Fragment>);
    }
    
    // Добавляем жирный текст
    const boldContent = match[1];
    parts.push(
      <strong key={`bold-${key++}`} className="faq-content__bold">
        {processLinks(boldContent)}
      </strong>
    );
    
    lastIndex = match.index + match[0].length;
  }
  
  // Добавляем оставшийся текст
  if (lastIndex < remaining.length) {
    const afterText = remaining.slice(lastIndex);
    parts.push(<React.Fragment key={`text-${key++}`}>{processLinks(afterText)}</React.Fragment>);
  }
  
  return parts.length > 0 ? parts : processLinks(text);
};

// Данные FAQ
const defaultFaqItems = [
  {
    id: 1,
    question: 'Как узнать точную стоимость покупки?',
    answer: `Чтобы рассчитать точную стоимость, нам нужно зайти в ваш аккаунт и проверить актуальные цены в игре. В некоторых играх разработчики оставляют цены близкими к указанным в игровом магазине, а в других стоимость может отличаться из-за региональной политики и курса иностранной валюты.

Каждый день мы публикуем минимум 12 постов с примерами реальных цен в разных играх в нашем Телеграм-канале: t.me/goplaydonate_online и в группе ВК: https://vk.com/goplaydonate

Наша комиссия за услугу составляет 100 рублей к итоговой стоимости покупки.

После проверки в вашем аккаунте мы сообщим точную сумму к оплате.`
  },
  {
    id: 2,
    question: 'Как происходит процесс покупки?',
    answer: `🔐 Процесс покупки (занимает около 20 минут):

<b>1. Авторизация в аккаунте</b>

Для оформления покупки нужен доступ к вашему игровому аккаунту. Вы отправляете логин и пароль (чаще всего логином является почта Google или Facebook). Иногда система может запросить код подтверждения.

Авторизация в вашем игровом аккаунте нужна для того, чтобы покупка начислилась именно на ваш аккаунт.

Все ваши данные полностью защищены. Мы удаляем их сразу после сделки. Также мы всегда рекомендуем сменить пароль после завершения диалога с администратором.

<b>2. Подтверждение аккаунта</b>

После входа в аккаунт мы отправляем вам скриншот, чтобы вы убедились, что это именно ваш аккаунт, и подтвердили, куда оформлять покупку.

<b>3. Расчет и оплата</b>

После подтверждения аккаунта мы считаем итоговую стоимость нужной покупки в рублях и отправляем вам платёжную ссылку для оплаты по карте банка или через СБП.

<b>4. Покупка</b>

После успешной оплаты, мы приступаем к покупке вашего товара, используя наши иностранные карты. В среднем весь процесс занимает около 20 минут.

<b>5. Отчёт</b>

После завершения покупки администратор сообщит вам и предложит проверить наличие товара в вашей игре или приложении.

Сделка будет закрыта только после вашего подтверждения.`
  },
  {
    id: 3,
    question: 'Какие способы оплаты доступны?',
    answer: `\u{1F1F7}\u{1F1FA} Для игроков из России: Мы принимаем все популярные способы оплаты: СБП, любые российские карты (МИР, Visa, Mastercard) и криптовалюту USDT. <b>Все расчёты в рублях — никаких сложностей с валютой!</b>

\u{1F1E7}\u{1F1FE} Для игроков из Белоруссии: Мы принимаем оплату по карте и через ЕРИП.

🌍 Для игроков из СНГ и остальных стран: Мы принимаем оплату в евро.

Для первого заказа в нашем сервисе действует акция: <b>комиссия сервиса 0% по промокоду GOPLAY55</b> (сообщите его администратору перед покупкой).

Каждый вторник мы публикуем промокоды на скидки в нашем Telegram-канале https://t.me/GoPlayDonate`
  },
  {
    id: 4,
    question: 'Безопасно ли покупать у нас?',
    answer: `<b>Да, абсолютно безопасно.</b>

За 3+ года работы мы обработали десятки тысяч заказов — ни одного потерянного доната.

<b>Как мы защищаем ваши данные:</b>
Ваши логин и пароль используются только один раз для покупки и сразу удаляются. Мы не храним их в системе. После покупки вы можете сразу сменить пароль — аккаунт под вашим полным контролем.

<b>Проверьте сами:</b>

Почитайте отзывы наших клиентов в сообществе ВК: https://vk.com/topic-225634454_50615327
Или в Телеграм-канале: t.me/goplay_review

Более 10 000 довольных игроков ежемесячно выбирают нас. Мы даём 100% гарантию доставки доната на ваш аккаунт.`
  },
  {
    id: 5,
    question: 'Что делать если возникли проблемы?',
    answer: `<b>Наша поддержка работает 24/7 без выходных.</b>

Если после завершения покупки вы обнаружили проблему — повторно откройте диалог с администратором и сообщите о проблеме, приложив скриншоты. Мы ответим в течение нескольких минут.

За каждым заказом закреплён персональный администратор, который доведёт ситуацию до полного решения.

<b>Мы не считаем работу выполненной, пока вы не подтвердите получение доната.</b> Если что-то пошло не так — обратимся в поддержку игры или поможем вам с обращением, и если в течение 7 дней это не принесёт результата — вернём деньги.`
  },
  {
    id: 6,
    question: 'Сколько времени занимает покупка?',
    answer: `<b>С момента, как администратор подключился к вашему заказу — 15-20 минут.</b>

Вы получаете уведомления на каждом этапе: «Захожу на аккаунт», «Рассчитываю стоимость покупки», «Совершаю покупку», «Донат зачислен, выхожу из аккаунта».

<b>Весь процесс прозрачный — вы видите, что именно происходит.</b> Задержки бывают только при высокой нагрузке на сервис или если иностранный банк задерживает оплату.`
  },
  {
    id: 7,
    question: 'Можно ли получить возврат средств?',
    answer: `Да. Если донат не пришёл после покупки — <b>мы помогаем обратиться в поддержку игры или приложения, предоставляем чеки и всю информацию для решения вопроса.</b>

Чаще всего поддержка игры отвечает быстро и зачисляет донат. Если в течение 7 дней вопрос не решится — делаем возврат средств. Возврат происходит тем же способом, которым вы оплачивали.`
  }
];

const FAQContent = ({ faqItems = defaultFaqItems }) => {
  const [openItemId, setOpenItemId] = useState(null);

  const handleToggle = (id) => {
    setOpenItemId(openItemId === id ? null : id);
  };

  return (
    <div className="faq-content">
      <div className="faq-content__list">
        {faqItems.map((item) => {
          const isOpen = openItemId === item.id;
          
          return (
            <div 
              key={item.id}
              className={`faq-content__item ${isOpen ? 'faq-content__item--open' : ''}`}
            >
              <button 
                className="faq-content__header"
                onClick={() => handleToggle(item.id)}
                aria-expanded={isOpen}
              >
                <span className="faq-content__question">{item.question}</span>
                <span className="faq-content__icon">
                  {isOpen ? <MinusIcon /> : <PlusIcon />}
                </span>
              </button>
              
              {isOpen && (
                <>
                  <div className="faq-content__divider" />
                  <div className="faq-content__body">
                    <p className="faq-content__answer">{formatText(item.answer)}</p>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQContent;
